export const contentBodySx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: {
    xs: 'center',
    md: 'flex-start'
  },
  flexDirection: 'column',
  transition: 'display 2s',
  width: '100%',
  maxWidth: '1200px',
  mx: 'auto'
};

export const termsBodySx = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column'
};

export const pageContainerSx = {
  width: '100%',
  px: {
    xs: 2,
    md: 5
  },
  py: 3
};

export const successBackgroundSx = {
  display: 'flex',
  width: '100%',
  background: 'linear-gradient(90deg, #60CE8C 17.24%, #48BDAF 100%), #2EB256',
  borderRadius: '5px 5px 0 0',
  p: 3.75,
  pt: 5,
  minHeight: 160,
  color: '#fff',
  flexDirection: 'column',
  alignItems: 'center',
  '& h1': {
    fontWeight: 300,
    color: '#fff',
    textAlign: 'center'
  },
  '& svg': {
    transform: 'scale(2)',
    mb: 2.5
  }
};
